module.exports = __webpack_public_path__ + "static/media/rules.c5745580.md";